import styled, { css } from 'styled-components';

import { Scrollbar } from '../../theme';
import { convertHexToRgba, getFontStyle, rem, toRemString } from '../../utils';

export type CSSResize = 'both' | 'horizontal' | 'vertical' | 'none';

export const StyledTextArea = styled.textarea<{
  disabled: boolean;
  resize: CSSResize;
  $isError: boolean;
  maxHeight?: number;
}>`
  width: 100%;
  ${getFontStyle('Body')};

  ${({ theme, resize, disabled, $isError, maxHeight }) => css`
    color: ${disabled ? theme.Color.Neutrals.Gray : theme.Color.Neutrals.Dark};
    flex: ${resize === 'vertical' ? 'initial' : 1};
    padding: ${rem(theme.Spacing.Size.Small)};
    border: ${rem(theme.Border.Size.Small)} solid
      ${!$isError ? theme.Color.Neutrals.Border : theme.Color.Feedback.Alert};
    border-radius: ${rem(theme.Form.TextArea.Radius)};
    resize: ${resize && !disabled ? resize : 'none'};
    max-height: ${resize === 'vertical' && !maxHeight
      ? rem(theme.Form.TextArea.MaxHeight)
      : 'auto'};
    background-color: ${disabled ? theme.Color.Neutrals.Light : theme.Components.Panel.Background};
    outline: none;
    transition: ${({ theme }) =>
      `box-shadow ${theme.Transition.Timing.Out}, border-color ${theme.Transition.Timing.Out}`};

    ${Scrollbar.ThinScrollbar}

    &:focus {
      box-shadow: ${toRemString([0, 0, 0, theme.Border.Size.Medium])}
        ${!$isError
          ? convertHexToRgba(theme.Color.Brand.Primary, 50)
          : convertHexToRgba(theme.Color.Feedback.Alert, 50)};
      border-color: ${!$isError ? theme.Color.Brand.Primary : theme.Color.Feedback.Alert};
      transition: ${({ theme }) =>
        `box-shadow ${theme.Transition.Timing.In}, border-color ${theme.Transition.Timing.In}`};
    }

    &:hover {
      border-color: ${!$isError ? theme.Color.Brand.Primary : theme.Color.Feedback.Alert};
      transition: border-color ${theme.Transition.Timing.In};
    }

    &:read-only {
      box-shadow: ${toRemString([0, 0, 0, 1])} inset ${theme.Color.Overlay.Light};
    }

    &::placeholder {
      opacity: unset;
      color: ${theme.Color.Neutrals.Gray};
    }
  `}
`;

export const StyledWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
  height: auto;
`;

export const StyledCounter = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

export const StyledError = styled.div``;
